import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const CompanyInfoPage: FC = () => {
  return <Outlet />;
};

export default CompanyInfoPage;
